var map = {
	"./Unattractive.png": 8675,
	"./children.png": 908,
	"./defect.png": 1746,
	"./discoloration.png": 6637,
	"./discomfort.png": 1837,
	"./mobile/Unattractive.png": 2350,
	"./mobile/children.png": 9625,
	"./mobile/defect.png": 2371,
	"./mobile/discoloration.png": 7322,
	"./mobile/discomfort.png": 8080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5806;